<ng-template #brand>
  <a *ngIf="logoToRoot; else externalLogo" class="brand__logo" [routerLink]="rootLink">
    <img src="/assets/home/logo.svg" alt="노는법" />
  </a>
  <ng-template #externalLogo>
    <a class="brand__logo" [href]="homeUrl" target="nnb-web" rel="noopener noreferrer">
      <img src="/assets/home/logo.svg" alt="노는법" />
    </a>
  </ng-template>
  <a class="brand__label" [routerLink]="rootLink">{{ label }}</a>
</ng-template>

<div class="shell" [class.shell--open]="open">
  <div class="topbar">
    <button type="button" class="hamburger" (click)="toggle()" aria-label="메뉴 열기" [attr.aria-expanded]="open">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <div class="topbar__brand">
      <ng-container [ngTemplateOutlet]="brand"></ng-container>
    </div>
  </div>

  <div class="body">
    <aside class="sidebar" aria-label="사이드 메뉴">
      <div class="sidebar__header">
        <ng-container [ngTemplateOutlet]="brand"></ng-container>
      </div>
      <!-- Close the mobile drawer on any nav click. NavigationEnd covers internal routing,
           but external links (target=_blank) and same-route clicks never fire it. -->
      <nav class="sidebar__nav" (click)="close()">
        <ng-container *ngFor="let item of menu">
          <hr class="sidebar__divider" *ngIf="item.dividerBefore" />
          <a
            *ngIf="item.externalUrl"
            class="nav-item"
            [href]="item.externalUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img class="nav-item__icon" [src]="item.icon" alt="" />
            <span class="nav-item__label">{{ item.label }}</span>
          </a>
          <a
            *ngIf="item.link"
            class="nav-item"
            [routerLink]="item.link"
            routerLinkActive="nav-item--active"
            [routerLinkActiveOptions]="item.exact ? exactMatch : prefixMatch"
          >
            <img class="nav-item__icon" [src]="item.icon" alt="" />
            <span class="nav-item__label">{{ item.label }}</span>
          </a>
        </ng-container>
      </nav>
    </aside>

    <div class="backdrop" (click)="close()"></div>

    <main class="main">
      <ng-content></ng-content>
    </main>
  </div>
</div>
